import React from "react";

export const search = (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <path fill="#d3d7db" fillOpacity="1" fillRule="nonzero"
              d="M19.587 17.586L15.202 13.2c.958-1.362 1.554-3.044 1.554-4.833C16.756 3.768 12.987 0 8.389 0 3.789 0 0 3.768 0 8.389c0 4.62 3.768 8.388 8.389 8.388 1.788 0 3.47-.575 4.833-1.554l4.385 4.364c.256.277.64.426.98.426.34 0 .724-.149.98-.426a1.395 1.395 0 0 0 .02-2zM2.832 8.39a5.56 5.56 0 0 1 5.557-5.557 5.56 5.56 0 0 1 5.556 5.557c0 3.065-2.512 5.556-5.556 5.556-3.045 0-5.557-2.512-5.557-5.556z"/>
    </svg>
); 

export const check = (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
        <defs>
            <path id="a" d="M0 0h14v14H0z"/>
        </defs>
        <g fill="none" fillRule="evenodd">
            <path fill="#FFF" fillRule="nonzero" stroke="#FFF" d="M9.595 5.078c.212-.232.55.106.338.338C8.755 6.748 7.567 8.06 6.38 9.383c-.058.068-.116.126-.174.193-.087.097-.25.087-.338 0-.598-.57-1.197-1.148-1.795-1.718-.222-.212.115-.56.337-.338.541.512 1.072 1.024 1.613 1.545a1328.42 1328.42 0 0 0 3.572-3.987z"/>
        </g>
    </svg>
);

export const expand = (
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
         viewBox="0 0 100 100" xmlSpace="preserve">
        <g>
            <path d="M84.2,39.2c-0.5,0-1-0.2-1.4-0.6l-33-33l-33,33c-0.8,0.8-2,0.8-2.8,0c-0.8-0.8-0.8-2,0-2.8L48.5,1.4c0.8-0.8,2-0.8,2.8,0
		l34.4,34.4c0.8,0.8,0.8,2,0,2.8C85.3,39,84.8,39.2,84.2,39.2z"/>
        </g>
        <g>
            <path d="M50.6,99c-0.5,0-1-0.2-1.4-0.6L14.8,64.1c-0.8-0.8-0.8-2,0-2.8c0.8-0.8,2-0.8,2.8,0l33,33l33-33c0.8-0.8,2-0.8,2.8,0
		s0.8,2,0,2.8L52,98.4C51.7,98.8,51.1,99,50.6,99z"/>
        </g>
    </svg>
);

export const plusCircle = (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 512 512">
        <path fill="currentColor" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"/>
    </svg>
);

export const angleRight = (
    <svg width="17" height="17" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
        <path fill="#0086ff" d="M1171 960q0 13-10 23l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23z"/>
    </svg>
);

export const angleDown = (
    <svg width="17" height="17" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
        <path fill="#0086ff" d="M1395 736q0 13-10 23l-466 466q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l393 393 393-393q10-10 23-10t23 10l50 50q10 10 10 23z"/>
    </svg>
);

export const close = (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
        <path fill="#FFF" fillRule="nonzero"
              d="M15.613.368c-.49-.49-1.3-.49-1.812 0l-5.8 5.8-5.82-5.8C1.69-.122.88-.122.367.368c-.49.49-.49 1.3 0 1.812l5.82 5.8L.39 13.801c-.49.49-.49 1.3 0 1.812.256.256.576.384.896.384.32 0 .66-.128.895-.384l5.821-5.82 5.821 5.82c.256.256.576.384.896.384.32 0 .66-.128.895-.384.49-.49.49-1.3 0-1.812l-5.8-5.821 5.822-5.821c.49-.49.49-1.3-.022-1.791z"/>
    </svg>
);

export const checkmark = (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="32" preserveAspectRatio="xMidYMid meet" viewBox="0 0 12 16">
        <path fill="#fff" fillRule="evenodd" d="M12 5l-8 8-4-4 1.5-1.5L4 10l6.5-6.5z"/>
    </svg>
);

export const warning = (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="29" viewBox="0 0 32 29">
        <path fill="#FFF" d="M31.443 22.594L19.598 2.078a4.155 4.155 0 0 0-7.197 0L.557 22.594a4.155 4.155 0 0 0 3.598 6.233h23.69a4.156 4.156 0 0 0 3.598-6.233zm-14.181.56c0 .662-.536 1.198-1.197 1.198H16a1.197 1.197 0 0 1-1.197-1.197v-.065c0-.661.536-1.197 1.197-1.197h.065c.66 0 1.197.536 1.197 1.197v.065zm-.065-3.687a1.197 1.197 0 1 1-2.394 0l-.776-10.871c0-.661 1.312-1.456 1.973-1.456s1.974.795 1.974 1.456l-.777 10.87z"/>
    </svg>
);

export const so_logo = (
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
         viewBox="0 0 1000 744" xmlSpace="preserve">
        <g>
            <path d="M871.9,526.7c-0.1,0-0.2,0-0.2,0l-198.5-0.4c-60.1-0.1-108.6-48.9-108.5-109c0.1-60,48.8-108.5,108.7-108.5
                c0.1,0,0.2,0,0.2,0l198.5,0.4c60.1,0.1,108.6,48.9,108.5,109C980.5,478.2,931.9,526.7,871.9,526.7z"/>
        </g>
        <circle cx="123.8" cy="418" r="108.8"/>
        <circle cx="671.9" cy="417.5" r="108.8"/>
        <path d="M347.9,527c-61,0-104.5-48.3-104.5-109.8c0-61,43.8-109.4,104.5-109.4c44.7,0,79.1,25.8,93.8,63.5l-34.8,14.7
    c-9.8-25-29.5-40.2-59-40.2c-39.7,0-66.4,29.5-66.4,71.3c0,42.2,26.6,71.7,66.4,71.7c26.2,0,44.2-12.3,55.3-33.6l36.1,12.7
    C423.7,503.2,391,527,347.9,527z"/>
        <path d="M476.5,447.5v-95.5h-34.8V314h34.8v-40.3h38.1V314h49.2v38.1h-49.2v90.1c0,27.5,5.7,40.6,30.3,40.6h19.7v38.1h-29.1
    C493.7,520.9,476.5,497.5,476.5,447.5z"/>
        <g>
            <path d="M697.9,52.1h37.7v204.9h-37.7v-31.2c-8.9,16.2-30.4,37.3-70.2,37.3c-56,0-99.4-47.1-99.4-108.7
            c0-61.3,43.4-108.3,99.4-108.3c39.8,0,61.3,21.5,70.2,37.3V52.1z M697.9,154.3c0-41.4-27.2-70.6-66.1-70.6
            c-38.9,0-65.7,29.2-65.7,70.6c0,41.8,26.8,71,65.7,71C670.8,225.3,697.9,196.1,697.9,154.3z"/>
        </g>
        <path d="M23.1,108.6c0-35.6,30.2-64.7,78.4-64.7c66.9,0,85.2,51.6,85.2,51.6l-31,19.7c0,0-13.9-33.6-54.1-33.6
	c-27.9,0-41,10.7-41,25.8c0,13.1,6.8,21.7,29.1,24.6l33.8,4.1c50.5,6.6,70,29.9,70,60.6c0,35.6-29.1,66.4-85.6,66.4
	c-73.6,0-90.7-53.7-90.7-53.7L47,190.1c0,0,14.3,35.2,60.5,35.2c36.6,0,48.2-12.7,48.2-27.9c0-13.5-7.6-21.7-33.4-25l-33.8-4.1
	C43.8,162.6,23.1,140.1,23.1,108.6z"/>
        <path d="M475.7,146.7c0-42.6-13.8-64.7-46.5-64.7c-35.7,0-51.2,24.2-51.2,71.3v103.7h-37.6V146.7c0-42.6-13.9-64.7-46.6-64.7
	c-35,0-49.9,22.9-49.9,68v106.9H205V51.2h37.8l-0.4,29.4c7.1-15.2,21.5-36.8,57.2-36.8c35.3,0,57.2,17.2,68.4,53.7l6-15.6
	c7.1-15.2,26.5-38.1,62.2-38.1c47.7,0,78.2,31.1,78.2,99.6v113.5h-38.8V146.7z"/>
        <path d="M963,218.8c-24.6,0-30.3-13.1-30.3-40.6V87.6h49.2V46.3h-49.2V9.6h-38.1v36.7H861h-1.2h-8.6c-31.1,0-48.8,10.6-59,34V52.1
	h-38.1v204.7h38.1V138.1c0.8-36.9,18-50.4,53.7-50.4H861v-0.1h33.6v95.9c0,50,17.2,73.3,59,73.3h29.1v-38.1H963z"/>
        <g>
            <path
                d="M32.8,598h23.6v18.8c6.4-14.5,17.3-22.6,36.6-22.6h6.1v25.7h-9.4c-22.1,0-32.8,9.9-33.3,32.8v73.7H32.8V598z"/>
            <path d="M124.5,670.7c3.3,21.3,19.3,35.8,40.6,35.8c18,0,29.2-9.4,35.3-21.6l22.6,8.4c-10.2,21.8-29.5,36.8-57.9,36.8
		c-37.9,0-64.8-30-64.8-68.1c0-37.9,27.2-67.8,63.5-67.8c35.3,0,62.7,27.7,62.7,67.6c0,3.3-0.5,8.9-0.5,8.9H124.5z M125.3,650.6h78
		c-4.1-21.3-20.3-32.8-39.4-32.8C144.6,617.9,129.3,631.1,125.3,650.6z"/>
            <path d="M344.2,598h23.6v128.3h-23.6v-19.6c-5.6,10.2-19.1,23.4-43.9,23.4c-35.1,0-62.2-29.5-62.2-68.1c0-38.4,27.2-67.8,62.2-67.8
		c24.9,0,38.4,13.5,43.9,23.4V598z M344.2,662.1c0-25.9-17-44.2-41.4-44.2s-41.2,18.3-41.2,44.2c0,26.2,16.8,44.5,41.2,44.5
		S344.2,688.2,344.2,662.1z"/>
            <path d="M393.3,548.5h23.6v177.8h-23.6V548.5z"/>
            <path d="M508.4,680.9v-59.2h-21.6V598h21.6v-38.1H532V598h30.5v23.6H532v55.9c0,17,3.6,25.2,18.8,25.2H563v23.6h-18
		C519,726.3,508.4,711.8,508.4,680.9z"/>
            <path d="M591.2,546.7c8.9,0,16,6.9,16,16c0,9.1-7.1,16-16,16s-16-6.9-16-16C575.2,553.6,582.3,546.7,591.2,546.7z M579.5,598h23.6
		v128.3h-23.6V598z"/>
            <path d="M821.6,658c0-26.4-11.9-40.1-34-40.1c-24.1,0-38.9,15-38.9,44.2v64.3h-23.6V658c0-26.4-11.9-40.1-34-40.1
		c-23.6,0-38.9,14.2-38.9,42.2v66.3h-23.6V598h23.6v19.8c4.8-9.4,19.6-23.6,43.7-23.6c23.9,0,41.2,10.7,48.8,33.3l4.1-9.7
		c4.8-9.4,19.6-23.6,43.7-23.6c32.3,0,52.8,19.3,52.8,61.7v70.4h-23.6V658z"/>
            <path d="M885.9,670.7c3.3,21.3,19.3,35.8,40.6,35.8c18,0,29.2-9.4,35.3-21.6l22.6,8.4c-10.2,21.8-29.5,36.8-57.9,36.8
		c-37.9,0-64.8-30-64.8-68.1c0-37.9,27.2-67.8,63.5-67.8c35.3,0,62.7,27.7,62.7,67.6c0,3.3-0.5,8.9-0.5,8.9H885.9z M886.6,650.6h78
		c-4.1-21.3-20.3-32.8-39.4-32.8C905.9,617.9,890.7,631.1,886.6,650.6z"/>
        </g>
    </svg>
);

export const threeDots = (
    <svg xmlns="http://www.w3.org/2000/svg" width="4" height="16" viewBox="0 0 4 16">
        <g fill="#1D364B" fillRule="nonzero">
            <circle cx="1.606" cy="1.6" r="1.6"></circle>
            <circle cx="1.606" cy="8" r="1.6"></circle>
            <circle cx="1.606" cy="14.4" r="1.6"></circle>
        </g>
    </svg>  
);

export const arrowDown = (
    <svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10">
        <path fill="#0086FF" fillRule="nonzero" d="M3.229 9.943a.75.75 0 0 0 .097.03l.043.012a.75.75 0 0 0 .295 0l.042-.012a.75.75 0 0 0 .098-.03l.03-.015a.75.75 0 0 0 .212-.145l2.75-2.75a.75.75 0 0 0-1.06-1.06L4.27 7.44V.75a.75.75 0 1 0-1.5 0v6.69l-1.47-1.47a.75.75 0 1 0-1.06 1.06l2.75 2.75a.75.75 0 0 0 .212.145l.028.018z" />
    </svg>
);

export const arrowUp = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 10" width="7" height="10">
        <path fill="#0086ff" id="Layer" className="shp0"
            d="M3.77,0.06c-0.03,-0.01 -0.06,-0.02 -0.1,-0.03l-0.04,-0.01c-0.1,-0.02 -0.2,-0.02 -0.29,0l-0.04,0.01c-0.03,0.01 -0.07,0.02 -0.1,0.03l-0.03,0.02c-0.08,0.04 -0.15,0.08 -0.21,0.14l-2.75,2.75c-0.28,0.3 -0.27,0.76 0.02,1.04c0.29,0.29 0.75,0.29 1.04,0.02l1.47,-1.47l0,6.69c0,0.41 0.34,0.75 0.75,0.75c0.41,0 0.75,-0.34 0.75,-0.75l0,-6.69l1.47,1.47c0.19,0.2 0.47,0.28 0.73,0.22c0.27,-0.07 0.47,-0.28 0.54,-0.54c0.07,-0.27 -0.01,-0.55 -0.22,-0.73l-2.75,-2.75c-0.06,-0.06 -0.13,-0.11 -0.21,-0.14l-0.03,-0.02z" />
    </svg>
);

export const dashboardArrowDown = (
    <svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10">
        <path fill="#8d8d8d" fillRule="nonzero" d="M3.229 9.943a.75.75 0 0 0 .097.03l.043.012a.75.75 0 0 0 .295 0l.042-.012a.75.75 0 0 0 .098-.03l.03-.015a.75.75 0 0 0 .212-.145l2.75-2.75a.75.75 0 0 0-1.06-1.06L4.27 7.44V.75a.75.75 0 1 0-1.5 0v6.69l-1.47-1.47a.75.75 0 1 0-1.06 1.06l2.75 2.75a.75.75 0 0 0 .212.145l.028.018z" />
    </svg>
);

export const dashboardArrowUp = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 10" width="7" height="10">
        <path fill="#8d8d8d" id="Layer" className="shp0"
            d="M3.77,0.06c-0.03,-0.01 -0.06,-0.02 -0.1,-0.03l-0.04,-0.01c-0.1,-0.02 -0.2,-0.02 -0.29,0l-0.04,0.01c-0.03,0.01 -0.07,0.02 -0.1,0.03l-0.03,0.02c-0.08,0.04 -0.15,0.08 -0.21,0.14l-2.75,2.75c-0.28,0.3 -0.27,0.76 0.02,1.04c0.29,0.29 0.75,0.29 1.04,0.02l1.47,-1.47l0,6.69c0,0.41 0.34,0.75 0.75,0.75c0.41,0 0.75,-0.34 0.75,-0.75l0,-6.69l1.47,1.47c0.19,0.2 0.47,0.28 0.73,0.22c0.27,-0.07 0.47,-0.28 0.54,-0.54c0.07,-0.27 -0.01,-0.55 -0.22,-0.73l-2.75,-2.75c-0.06,-0.06 -0.13,-0.11 -0.21,-0.14l-0.03,-0.02z" />
    </svg>
);

export const ArrowLeft = ({color} : {color : string}) => {
    return  (
        <svg enableBackground="new 0 0 15 26" height="12px" id="Layer_1" version="1.1" 
            viewBox="0 0 15 26" width="15px" xmlSpace="preserve" xmlns="http://www.w3.org/2000/svg" 
            xmlnsXlink="http://www.w3.org/1999/xlink">
                <polygon fill="#fff" 
                    points="12.885,0.58 14.969,2.664 4.133,13.5 14.969,24.336 12.885,26.42 2.049,15.584 -0.035,13.5 "
                    style={{stroke: color,strokeWidth: "1px"}}/>
        </svg>
    )
}

export const ArrowRight = ({color} : {color : string}) => {
    return (
        <svg enableBackground="new 0 0 15 26" height="12px" 
            id="Layer_1" version="1.1" viewBox="0 0 15 26" width="15px" 
                xmlSpace="preserve" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                <polygon fill="#fff" 
                points="2.019,0.58 -0.035,2.634 10.646,13.316 -0.035,23.997 2.019,26.052 14.755,13.316 "
                style={{stroke: color,strokeWidth: "1px"}}/>
        </svg>
    )
}